import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

// MUI styles flipped for right-to-left (MUI's RTL guide): the theme says rtl, but the
// app sets no page direction and emotion doesn't flip left/right on its own, so text
// field labels and outlines stay on the left. A component that needs proper RTL wraps
// itself in <CacheProvider value={rtlCache}> and sets dir="rtl" (dialogs render in a
// portal, so each one sets its own). Styles inside are written as for LTR and flipped.
export const rtlCache = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
